import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import blank from "Media/blank-profile-picture.png";
import firebase from "firebase/compat/app";
import moment from "moment-timezone";
import { renderChatProfileAction } from "Redux/action/render.action";
import { seenOnClick } from "Components/Chat/ChatTimer/ChatTimer";
import profilePic from "Media/blank-profile-picture.png";
import ExternalIcon from "Media/icons/External_icon.svg";
const ChatUserSubCard = () => {
  const user_data_list = useSelector((state) => state.renderRecentChatUserReducer);
  const my_id = useSelector((state) => state.authenticationReducer?.id);
  const send_by = useSelector((state) => state.authenticationReducer?.id);
  const dispatch = useDispatch();
  const [allMessages, setAllMessages] = useState([]);

  useEffect(() => {
    const unsubscribe = firebase
      .firestore()
      .collection("chatroom")
      .orderBy("createdAt", "desc")
      .onSnapshot((querySnap) => {
        const newData = querySnap.docs.map((doc) => {
          const data = doc.data();
          return {
            ...data,
            createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : new Date(),
            docID: doc.id,
          };
        });

        setAllMessages((prev) => {
          const prevStringified = JSON.stringify(prev);
          const nextStringified = JSON.stringify(newData);
          return prevStringified === nextStringified ? prev : newData;
        });
      });

    return () => unsubscribe();
  }, []);

  const uniqueUserList = React.useMemo(() => {
    if (!Array.isArray(user_data_list) || user_data_list.length === 0) return [];

    const seen = new Set();
    return user_data_list.filter((curr) => {
      const key = curr?.id ?? curr?.unique_id;
      if (key == null || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }, [user_data_list]);

  const getConversationKey = React.useCallback((currEle) => {
    if (currEle?.type?.toString() === "group") return currEle?.docID;
    if (Array.isArray(currEle?.chatID)) {
      return [...currEle.chatID].sort().join("_");
    }
    return currEle?.docID;
  }, []);

  const RenderChatList = React.memo(({ message, time, curr, date, seen_data, docid }) => {
    let lastMessage = message ?? "";
    while (lastMessage.includes("&*&")) {
      lastMessage = lastMessage.replace("&*&", "\n");
    }

    let recent_msg = false;
    if (seen_data) {
      for (let i in seen_data) {
        if (
          Object.values(seen_data[i])?.toString() === "unseen" &&
          Object.keys(seen_data[i])?.toString() === send_by?.toString()
        ) {
          recent_msg = true;
        }
      }
    }

    const handleChatClick = () => {
      dispatch(renderChatProfileAction(curr?.unique_id));

      if (seen_data) {
        const update_seen_data = seenOnClick(seen_data, send_by);
        firebase.firestore().collection("chatroom").doc(docid).update({
          seen_data: update_seen_data,
        });
        firebase.firestore()
          .collection("chatroom")
          .doc(docid)
          .collection("seenStatus")
          .doc(String(send_by))
          .set({
            lastSeenAt: firebase.firestore.FieldValue.serverTimestamp(),
          });
      }
    };

    return (
      <div
        className={
          recent_msg ? "chatusercard-container recent-msg" : "chatusercard-container"
        }
        onClick={handleChatClick}
      >
        <div>
          <div className="chat-screen-logo">
            <img
              src={curr?.image || blank}
              alt="Logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = blank;
              }}
            />

            {curr?.chat_scope === "external" && (
              <span className="external-icon">
                <img
                  src={ExternalIcon || profilePic}
                  alt="External"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = profilePic;
                  }}
                />
              </span>
            )}

            <div className="chat-screen-status-dot">
              {!curr?.chat_type &&
                curr?.chat_type !== "group" &&
                (curr?.online_status?.toString() === "online" ? (
                  <span className="user-status" style={{ color: "#87c823" }}>
                    <FiberManualRecordIcon />
                  </span>
                ) : (
                  <span className="user-status" style={{ color: "#c23616" }}>
                    <FiberManualRecordIcon />
                  </span>
                ))}
            </div>
          </div>
          <div className="chat-screen-profile">
            <h5>{curr?.name ? curr?.name : "No Name"}</h5>
            <p>{lastMessage ? lastMessage : "..."}</p>
          </div>
        </div>
        <div className="chat-screen-time">
          <span>{time ? time : null}</span>
          <span>{date ? date : null}</span>
        </div>
      </div>
    );
  });

  const chatRows = React.useMemo(() => {
    if (!Array.isArray(allMessages) || allMessages.length === 0) return [];

    const renderedConversationKeys = new Set();
    const rows = [];

    uniqueUserList.forEach((curr) => {
      allMessages.forEach((currEle) => {
        const conversationKey = getConversationKey(currEle);
        if (!conversationKey || renderedConversationKeys.has(conversationKey)) {
          return;
        }

        if (currEle?.type?.toString() === "group") {
          if (curr?.unique_id?.toString() !== currEle?.docID?.toString()) {
            return;
          }

          renderedConversationKeys.add(conversationKey);
          const date = moment(currEle?.createdAt).tz("Europe/Paris").format();
          rows.push(
            <RenderChatList
              key={conversationKey}
              message={currEle?.lastMessage}
              time={moment(date).format("hh:mm A")}
              curr={curr}
              date={moment(date).format("MM/DD/YYYY")}
              seen_data={currEle?.seen_data}
              docid={currEle?.docID}
            />
          );
          return;
        }

        if (!Array.isArray(currEle?.chatID) || !currEle.chatID.length) {
          return;
        }

        const isMyConversation = currEle.chatID.some(
          (memberId) => my_id?.toString() === memberId?.toString()
        );
        const matchesCurrentUser = currEle.chatID.some(
          (memberId) => curr?.id?.toString() === memberId?.toString()
        );

        if (!isMyConversation || !matchesCurrentUser) {
          return;
        }

        renderedConversationKeys.add(conversationKey);
        const date = moment(currEle?.createdAt).tz("Europe/Paris").format();
        rows.push(
          <RenderChatList
            key={conversationKey}
            message={currEle?.lastMessage}
            time={moment(date).format("hh:mm A")}
            curr={curr}
            date={moment(date).format("MM/DD/YYYY")}
            seen_data={currEle?.seen_data}
            docid={currEle?.docID}
          />
        );
      });
    });

    return rows;
  }, [allMessages, getConversationKey, my_id, uniqueUserList]);

  return (
    <>
      {uniqueUserList.length?.toString() !== "0" ? (
        chatRows
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          No Recent Chats
        </div>
      )}
    </>
  );
};

export default ChatUserSubCard;
